/* eslint-disable */
export default {
  _incorrect: 'incorrect',
  _tick: 'tick',
  _digital_down: 'digital_down',
  _cat_jump_ship: 'cat_jump_ship',
  _title_theme: 'title_theme',
  _transition: 'transition',
  _theme_level2: 'theme_level2',
  _landing: 'landing',
  _theme_level1: 'theme_level1',
  _digital_up: 'digital_up',
  _theme_level3: 'theme_level3',
  _correct2: 'correct2',
  _correct1: 'correct1',
  _theme_level4: 'theme_level4',
  _take_off: 'take_off',
  _click: 'click',
}